<template>
  <el-button size="mini" type="danger" @click="deleteIP()">Delete</el-button>
</template>

<script>
import { deleteIP } from "@/api/ip-server";
export default {
  props:{
    uid:String
  },
  methods:{
    deleteIP(){
      this.$confirm('Are you sure you want to delete this IP, Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          deleteIP(this.uid).then(({result})=>{
            if(result){
              this.$notify({
              title: 'Success',
              message: `Delete IP successfully`,
              type: 'success',
              duration: 2000
            });
              this.$emit("on-submited", true);
            }
          })
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });          
        });
    }
  }
}
</script>

<style>

</style>